<template>
  <div>
  	<common-dialog
    :title="dialogTitle"
    :dialogVisible="visible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
      	<div v-if="dialogType === 'add' || dialogType === 'edit'">
      		<div class="item-wrap">
      			<label>身份名称:</label>
      			<el-input v-model="addBody.title" placeholder="请输入身份名称" class="name_input"></el-input>
      		</div>
      		<div class="item-wrap">
      			<label>管理模块:</label>
					  <el-tree
		          :data="powerTree"
		          show-checkbox
		          :default-expand-all="true"
		          node-key="id"
		          ref="tree"
		          :props="defaultProps"/>
		      </div>
	      </div>
	      <div v-if="dialogType === 'delete'">
	      	是否删除该身份？
	      </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import CommonDialog from '@/components/CommonDialog';
import { LimitsList, addLimitsUser, SetLimitsList, delLimitsUser } from '@/api/auth';

export default {
	props: {
    dialogVisible: {
    	type: Boolean,
    	default: false
    },
    dialogTitle: {
    	type: String
    },
    dialogType: {
    	type: String,
    },
    handle_row: {
    	type: Object
    }
	},
  data() {
    return {
    	visible: this.dialogVisible,
      powerTree: [],
      defaultProps: {
        children: 'children',
        label: 'menu_name',
      },
      addBody:  {
      	title: '',
        rules_url: [],
        store_uuid: [],
        rules: [],
        rules_name: [],
      },
      second_rules: [],//二级列表的权限
    };
  },
  components: {
  	CommonDialog,
  },
  mounted() {
  },
  methods: {
  	dialogCancelClick() {
      this.$emit('cancel');
  	},
  	async dialogConfirmClick() {
      // this.$emit('confirm')
      if (this.dialogType === 'edit' || this.dialogType ==='add') {
      	const tree = this.$refs.tree.getCheckedNodes(true)
	      let fidArr = []; //存放父级rule id 
	      this.addBody.rules = [];
	      this.addBody.rules_name = [];
	      tree.forEach((item) => {
	        fidArr.push(item.fid);
	        this.addBody.rules.push(item.id)
	        this.addBody.rules_name.push(item.menu_name)
	      })
	      //fidArr去重添加到权限列表 子有权限 父级肯定也有权限
	      let result = [...new Set(fidArr)];
	      this.addBody.rules = this.addBody.rules.concat(result);
        console.log(this.addBody, 'rules')
      }
      switch(this.dialogType) {
      	case 'add': 
          {
          	const { status } = await addLimitsUser(this.addBody);
          	if (status === 200 ) {
          		this.visible = false;
          		break;
          	}
          }
        case 'edit':
          {
          	const { data, status } = await SetLimitsList(this.addBody);
          	if (status === 200 ) {
          		this.visible = false;
          		break;
          	}
          }
        case 'delete':
          {
          	const { data, status } = await delLimitsUser(this.handle_row.id);
          	if (status === 200 ) {
          		this.visible = false;
          		break;
          	}
          }
      }
  	},
  	dialogClose() {
      this.$emit('close');
  	},
  	async getLimitList() {
  		const { data, status } = await LimitsList();
  		if (status!== 200) return
			let copyData = JSON.parse(JSON.stringify(data));
		  if (copyData.one.length) {
	      copyData.one.forEach(one => {
          one.children = one.two;
	         one.two.forEach(two=> {
	          two.children = two.three;
            //存放二级列表权限id
            this.second_rules.push(two.id);
	         })
	      })
	    }
      this.powerTree = copyData.one;
  	}
  },
  watch: {
  	async dialogVisible(val) {
  		this.visible = val;
  		if (val) {
  			let row = this.handle_row;
        //getlimitlist是异步的需要加await 否则second_rules会出问题
        await this.getLimitList();
        //把二级列表权限去掉。否则三级权限会处于全选状态
        let rules = row.rules.filter(item => {
          return !this.second_rules.includes(item);
        })
        if (row.rules && row.rules.length && this.dialogType !== 'delete') {
        	this.$nextTick( () => {
            this.addBody = JSON.parse(JSON.stringify(row));
            this.$refs.tree.setCheckedKeys(rules)
        	})
        }
  		}
  	}
  }
};
</script>

<style lang="less" scoped>
.dialog-body-wrap {
	text-align: center;
	.item-wrap {
		display: flex;
		margin-bottom: 30px;
		label {
			width: 80px;
			margin-right: 40px;
		}
		.name_input {
			width: 200px;
		}
	}
}
</style>
